import React from 'react'
import PropTypes from 'prop-types'

function RedCloseIcon({ title }) {
  const titleId = title ? 'red-close-icon-title' : undefined

  return (
    <svg
      className="red-close-icon"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? 'img' : 'presentation'}
      aria-labelledby={titleId}
      aria-hidden={!title}
    >
      {title && <title id={titleId}>{title}</title>}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.00008 6.41423L1.70718 9.70712L0.292969 8.29291L3.58586 5.00001L0.292969 1.70712L1.70718 0.292908L5.00008 3.5858L8.29297 0.292908L9.70718 1.70712L6.41429 5.00001L9.70718 8.29291L8.29297 9.70712L5.00008 6.41423Z"
        fill="#DC3545"
      />
    </svg>
  )
}

RedCloseIcon.propTypes = {
  title: PropTypes.string,
}

export default RedCloseIcon
